import type { FaireThemeEntity } from "../../entity_types/theme";

export const safe_and_non_toxic_kids: FaireThemeEntity = {
  token: "safe-and-non-toxic-kids",
  type: "theme",
  name: "Safe & Non-Toxic Kids",
  description: "Gentle solutions for little ones -- chemical-free bath bombs to safe herbal support.",
  teaser: "Chemical-free kids' wellness your parent customers will love.",
  detail: "Your history of babygowns, kids' makeup, and youth sweatshirts shows a significant customer base for premium children's goods. KIDS BATH BOMBS and Children's Relief (no willow bark) are specifically designed safe for kids.",
  bgColor: "#F5E6C8",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_aux6zsfr9t",
    "p_sd4g2rste3",
    "p_p97k4v76e3",
    "p_7xc38yc6gq",
    "p_5az3q9z5hc",
    "p_ca8vg3knqx",
    "p_df9jt0hwsn",
    "p_89hzri8q58",
    "p_6bqyrkmnpc",
    "p_q9e66qz8ud",
    "p_8sngrk8bz9",
    "p_2gsdpcnbjn",
    "p_s8mwgeq2vj",
    "p_6h33ns0q1u",
    "p_qm726sqfwg",
    "p_9qkh2kdq7t",
    "p_ao6y1u2z37",
    "p_1386xqnw1j",
    "p_w5k3kjqdsm",
    "p_mhczqyx4zh",
    "p_jk4m6jeuc7",
    "p_b9dm8btcqc",
    "p_carq2n9wxg",
    "p_6gw9wr3wv9",
    "p_tvs6hkzhf6",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
